import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import WhyUsersSection from './components/WhyUsersSection';
import FeaturedGuides from './components/FeaturedGuides';
import SeoArticlesSection from './components/SeoArticlesSection';
import ComparisonTable from './components/ComparisonTable';
import CategoryButtons from './components/CategoryButtons';
import SafetyDisclaimer from './components/SafetyDisclaimer';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.tattoo';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Basetao Sheet',
  url: siteUrl,
  description:
    'The most comprehensive English resource for Basetao Spreadsheet — featuring product finds databases, shipping guides, warehouse tips, reviews, discount codes, and expert shopping advice.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Basetao Sheet',
  url: siteUrl,
  description:
    'Independent educational resource providing comprehensive Basetao Spreadsheet guides, reviews, shipping cost breakdowns, and product discovery tools for international shoppers.',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema as Record<string, unknown>} />
      <JsonLd data={organizationSchema as Record<string, unknown>} />
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <WhyUsersSection />
        <FeaturedGuides />
        <SeoArticlesSection />
        <ComparisonTable />
        <CategoryButtons />
        <div id="safety">
          <SafetyDisclaimer />
        </div>
      </main>
      <Footer />
    </>
  );
}